export default __webpack_public_path__ + "static/media/logo-white.4f654f45.png";